import { Body } from "../../../components/main-body/body";
import { LegalDocumentModal } from "./component/legal-document-modal";
import "./legal-document-management.css";
// import DropdownFilters from "../../../components/dropdown-filters/dropdown-filters";
import { useAdminResource } from "../components/hooks/useAdminResource";
import ApiLegalDocuments from "../../../api/legal-document-management";
import AdminResourceTable from "../components/layouts/general/admin-resource-table";
import { useParams, useLocation } from "react-router-dom";
import { useCallback, useEffect } from "react";
import useNotification from "../../../components/notification/notification";
import useAdminEvents from "../../../hooks/useAdminEvents";

export const LegalDocumentManagement = ({mode}) => {
  const {
    form,
    list,
    active,
    update,
    open,
    close,
    // createAndOpen,
    isLoading,
    getResources,
    updateResourceSilent,
    updateSorting,
    hasMore,
    fetchNext,
  } = useAdminResource(ApiLegalDocuments, "legalDocuments", "legalDocuments.notification", "legal-documents", "legalDocument");

  const { id } = useParams();
  const location = useLocation();
  const { openNotification } = useNotification();

  const refreshLegalDocuments = useCallback(() => {
    getResources();
  }, [getResources]);

  useAdminEvents({
    onLegalDocumentChanged: refreshLegalDocuments,
  });

  useEffect(() => {
    if (id && list.length) {
      const currentItem = list.find((item) => item.id === id);
      if (currentItem) {
        open(currentItem, mode);
      }
    }
  }, [id, list]);

  useEffect(() => {
    if (!id && active && mode !== "create") {
      close();
    }
  }, [location.pathname, id, active, mode]);

  const handlePublish = async (id) => {
    try {
      await ApiLegalDocuments.publish(id);
      openNotification?.({
        type: "success",
        message: <p>Document has been published</p>,
      });
      // await new Promise(resolve => setTimeout(resolve, 3000));
      await getResources();
    } catch (error) {
      console.error("Publish error:", error);
      openNotification?.({
        type: "error",
        message: <p>Failed to publish Article</p>,
      });
    }
  };

  const handleDiscard = async (id) => {
    try {
      await ApiLegalDocuments.discard(id);
      openNotification?.({
        type: "success",
        message: <p>Changes discarded</p>,
      });
      // await new Promise(resolve => setTimeout(resolve, 3000));
      await getResources();
      // close();
    } catch (error) {
      console.error("Discard error:", error);
      openNotification?.({
        type: "error",
        message: <p>Failed to discard changes</p>,
      });
    }
  };

  return (
    <Body
      header={{
        title: "Legal documents"
      }}
    >
      <LegalDocumentModal
        legalDocumentId={active?.id}
        form={form}
        data={active}
        onClose={close}
        onSave={update}
        isLoading={isLoading}
        mode={mode}
        onDiscard={handleDiscard}
        onPublish={handlePublish}
        onSaveSilent={updateResourceSilent}
      />
      <AdminResourceTable
        data={list}
        onHandleRowClick={open}
        tableColumnKeys={["title", "status", "updatedAt"]}
        isLoading={isLoading}
        updateSorting={updateSorting}
        hasMore={hasMore}
        fetchData={fetchNext}
      />
    </Body>
  );
};
